import { GuardStepResult } from "@/hooks/useGuardStep";
import { Step } from "@/types/flows";
import { useFlowState } from "../useFlowState";
import { useParams } from "react-router-dom";
import { useCurrentMedia } from "@/store";

export type UseGuardStep = (expectedStep: Step) => GuardStepResult;

export const useGuardBuildStep: UseGuardStep = (expectedStep) => {
    const { workspaceUrl } = useParams<{ workspaceUrl: string }>();
    const { step } = useFlowState();
    const currentMedia = useCurrentMedia();

    if (!currentMedia) {
        return {
            loading: false,
            step,
            passThrough: false,
            errors: [],
            redirect: workspaceUrl ? `/${workspaceUrl}` : "/"
        };
    }

    const authorizedStep = step === expectedStep;
    if (authorizedStep) {
        return { loading: false, step, passThrough: true, errors: [] };
    }

    return {
        loading: false,
        step,
        passThrough: false,
        errors: [`[Guard Build Step] Invalid step - ${step}. Expected ${expectedStep}`],
        redirect: workspaceUrl ? `/${workspaceUrl}` : "/"
    };
};
